/* eslint-disable */
import React from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<header className="account-selection">
    <div className="content-wrap">
      <Logo />
    </div>
		<div className="progress-step grey-out">
			<h2 className="step-number">1</h2>
			<p className="step-description">Type in your email address</p>
		</div>
		<div className="progress-step">
			<h2 className="step-number">2</h2>
			<p className="step-description">Choose your ad account</p>
		</div>
		<div className="progress-step grey-out">
			<h2 className="step-number">3</h2>
			<p className="step-description">Analyze your results</p>
		</div>
    <div className="content-wrap">
			{children}
    </div>
  </header>
)



// WEBPACK FOOTER //
// ./src/containers/AccountSelectorTopLeads/wrapper.js